import NewInspect from "@/views/customer/quality_control/destination/NewInspect.vue";
import EditInspect from "@/views/customer/quality_control/destination/EditInspect.vue";
import ListAgroExporters from "@/views/customer/quality_control/destination/ListAgroExporters.vue";
import ListContainers from "@/views/customer/quality_control/destination/ListContainers.vue";
import ListTemplates from "@/views/customer/quality_control/destination/ListTemplates.vue";
import ListInspects from "@/views/customer/quality_control/destination/ListInspects.vue";
import ShowInspect from "@/views/customer/quality_control/destination/ShowInspect.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "customer",
  role: "quality_control",
  permission: "destination",
});

export default [
  {
    path: "/customer/:customer_id/quality_control/destination/new_inspection/:agro_exporter_id/:container_id/:exporter_process_quality_template_id/:quality_template_id",
    name: routeName("new_inspect"),
    component: NewInspect,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/edit_inspection/:agro_exporter_id/:container_id/:exporter_process_quality_template_id/:quality_template_id/:quality_inspect_id",
    name: routeName("edit_inspect"),
    component: EditInspect,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/list_agro_exporters",
    name: routeName("list_agro_exporters"),
    component: ListAgroExporters,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/list_containers/:agro_exporter_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/list_templates/:agro_exporter_id/:container_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/list_inspects/:agro_exporter_id/:container_id/:exporter_process_quality_template_id",
    name: routeName("list_inspects"),
    component: ListInspects,
    props: true,
    meta: META
  },
  {
    path: "/customer/:customer_id/quality_control/destination/show_inspect/:agro_exporter_id/:container_id/:exporter_process_quality_template_id/:quality_inspect_id",
    name: routeName("show_inspect"),
    component: ShowInspect,
    props: true,
    meta: META
  }
];
